// Native
import { useState } from "react"
import { useNavigate } from "react-router"

// Components
import { Box, Center, ModalBody, Spinner, Stack, Text } from "@chakra-ui/react"
import { Modal, Pressable, Profile, Searchable, Show } from "components"

// Hooks
import { useSearch } from "hooks";

export default function Search(props){

    const navigate = useNavigate()
    const [ term, setTerm ] = useState()
    const search = useSearch(term)

    return(
    <Modal title="Busca global" size="2xl" {...props}>
        <ModalBody>

            <Searchable
                placeholder="Pesquisar por consultores, núcleos ou pedidos..."
                setValue={setTerm}
            />

            <Show visible={search.isFetching}>
                <Center my={8}><Spinner /> <Text ml={4} children="Buscando..." /></Center>
            </Show>

            <Stack spacing={4} mt={4}>
                
                <Show visible={search.data?.consultants?.length >= 1}>
                    <Text children="Consultores:" fontSize="sm" fontWeight="bold" />
                    <Stack spacing={1}>{ search.data?.consultants?.map(item => <Consultant key={item.id} data={item} onClick={() => navigate(`/consultants/${item.id}`)} />) }</Stack>
                </Show>

                <Show visible={search.data?.distributors?.length >= 1}>
                    <Text children="Núcleos:" fontSize="sm" fontWeight="bold" />
                    <Stack spacing={1}>{ search.data?.distributors?.map(item => <Distributor key={item.id} data={item} onClick={() => navigate(`/distributors/${item.id}`)} />) }</Stack>
                </Show>

                <Show visible={search.data?.orders?.length >= 1}>
                    <Text children="Pedidos:" fontSize="sm" fontWeight="bold" />
                    <Stack spacing={1}>{ search.data?.orders?.map(item => <Order key={item.id} data={item} />)  }</Stack>
                </Show>
                

            </Stack>
        </ModalBody>
    </Modal>
    )
}

const Consultant = ({ data, ...props }) => (
    <Pressable {...props}>
        <Box w="100%" py={2} px={4} borderLeftWidth={3} borderRadius={4} bgColor="rgba(0,0,0,0.04)">
            <Profile name={data?.customer?.name} />
        </Box>
    </Pressable>
)

const Distributor = ({ data, ...props }) => (
    <Pressable {...props}>
        <Box w="100%" py={2} px={4} borderLeftWidth={3} borderRadius={4} bgColor="rgba(0,0,0,0.04)">
            <Profile name={data?.name} />
        </Box>
    </Pressable>
)

const Order = ({ data, ...props }) => (
    <Pressable {...props}>
        <Box w="100%" py={2} px={4} borderLeftWidth={3} borderRadius={4} bgColor="rgba(0,0,0,0.04)">
            <Text children={data.cod} />
        </Box>
    </Pressable>
)